import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, ArrowRight } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-studio-hub-33/artifacts/l67b1y1e_Color%20logo%20-%20no%20background.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error("Please enter a password");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API}/admin/login`, { password });
      if (response.data.success) {
        // Store credentials for Basic Auth
        localStorage.setItem("adminAuth", btoa(`admin:${password}`));
        toast.success("Access granted");
        navigate("/admin/dashboard");
      }
    } catch (error) {
      toast.error("Invalid password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen neural-grid flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <a href="/" className="inline-block mb-8">
            <img src={LOGO_URL} alt="Inopsia" className="h-8 mx-auto" />
          </a>
          <h1 className="font-heading font-bold text-2xl md:text-3xl uppercase mb-2">
            Admin Access
          </h1>
          <p className="text-gray-500 text-sm">
            Enter your password to continue
          </p>
        </div>

        <form onSubmit={handleLogin} className="card-base p-8" data-testid="admin-login-form">
          <div className="mb-6">
            <label className="form-label flex items-center gap-2">
              <Lock size={14} /> Password
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-base w-full"
              placeholder="Enter admin password"
              autoFocus
              data-testid="admin-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="btn-primary w-full flex items-center justify-center gap-2"
            data-testid="admin-login-submit"
          >
            {loading ? "Verifying..." : "Access Dashboard"} <ArrowRight size={16} />
          </Button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-gray-500 hover:text-[#F87931] text-sm font-mono">
            &larr; Back to Website
          </a>
        </div>
      </div>
    </div>
  );
}
